import { Component, OnInit, Input, AfterViewInit  } from '@angular/core';
import { Entry } from 'contentful';
import { SecureLink, Footer } from '../../_models/footer.model';
import { ImageLink } from '../../_models/imageLink.model';
import { DomSanitizer, SafeUrl } from '@angular/platform-browser';
import { Theme } from '../../_models/theme.model';
import { FormBrandService } from '../../_services/form-brand.service';
import { WindowService } from '../../_services/window.service';

@Component({
  selector: 'app-footer',
  standalone: false,
  templateUrl: './footer.component.html',
  styleUrl: './footer.component.css'
})
export class FooterComponent implements OnInit, AfterViewInit {
  @Input() footerContent: Entry<Footer> | undefined;
  @Input() themeContent: Entry<Theme> | undefined;

  imgLinks: any[] = [];
  textLinks: any[] = [];
  
  constructor(
    private sanitizer: DomSanitizer,
    private formBrandService: FormBrandService,
    private windowService: WindowService
  ) {}
  
  ngOnInit() {
    this.loadImgLinks();
    this.loadTextLinks();
  }

  ngAfterViewInit() {
    this.formBrandService.getFormBrandSettingsObservable().subscribe(data => {
      this.loadFormBrandLinks();      
    });
  }


  getSafeUrl(url?: string): SafeUrl {
    return this.sanitizer.bypassSecurityTrustUrl(url || '');
  }

  getSafeImageUrl(imglink?: Entry<ImageLink>): SafeUrl {
    if (!imglink?.fields?.backGroundImageUrl?.['fields']?.['file']?.['url']) {
      return this.sanitizer.bypassSecurityTrustResourceUrl('');
    }
    
    const url = `https:${imglink.fields.backGroundImageUrl?.['fields']?.['file']?.['url']}`;
    return this.sanitizer.bypassSecurityTrustResourceUrl(url);
  }  

  openSecureWindow(link?: Entry<SecureLink>, openInNewTab: boolean = false) {
  if (!link?.fields) return;
  if (!this.windowService.window) return;

  const url = link.fields.linkUrl as unknown as string;

  if (openInNewTab) {
    //window.open(url, '_blank')?.focus(); //JLFranco
    this.windowService.window?.open(url, '_blank')?.focus();
  } else {
    const features = `
      width=${link.fields.windowWidth},
      height=${link.fields.windowHeight},
      scrollbars=${link.fields.scrollbarsEnabled ? 'yes' : 'no'}
    `;
    //window.open(url, 'SecureRights', features)?.focus(); //JLFranco
    this.windowService.window?.open(url, 'SecureRights', features)?.focus();
  }
  }
  
  loadImgLinks() {
    this.imgLinks = this.footerContent?.fields.imageLinks as unknown as [];
  }

  loadTextLinks() {
    this.textLinks = this.footerContent?.fields.textLinks as unknown as [];    
  }

  loadFormBrandLinks() {
    var brandSettings = this.formBrandService.getCachedFormBrandSettings();
    const doc = this.windowService.document;
    if (!doc) {
      return;
    }
    

    var termsAndConditionsLink;
    var privacyandPolicyLink;
    if(brandSettings) {
      if(brandSettings['CO'] == '1') {
        termsAndConditionsLink = brandSettings?.tcLinkGeneral;
        privacyandPolicyLink = brandSettings?.privacyLinkGeneral;
      } else {
        termsAndConditionsLink = brandSettings?.tcLinkProd;
        privacyandPolicyLink = brandSettings?.privacyLinkProd;
      }  
  
      var disclousure3TextProd = this.replaceVariables(brandSettings.disclousure3TextProd, brandSettings)
      if(disclousure3TextProd){
        //(document.getElementById('footerdisclaimer') as HTMLElement).innerHTML = disclousure3TextProd; //JLFranco
        (doc.getElementById('footerdisclaimer') as HTMLElement).innerHTML = disclousure3TextProd;
      }
    
      //document.getElementById('tcLink')?.setAttribute('href', termsAndConditionsLink); //JLFranco
      doc.getElementById('tcLink')?.setAttribute('href', termsAndConditionsLink);
      //document.getElementById('privacyLink')?.setAttribute('href', privacyandPolicyLink); //JLFranco
      doc.getElementById('privacyLink')?.setAttribute('href', privacyandPolicyLink);
    }
  }


  replaceVariables(text: string, params: { [key: string]: any }): string {
    if (!text || !params) return text;
    
    return text.replace(/\{\{(\w+)\}\}/g, (match, variableName) => {
      if (params[variableName] !== undefined) {
        return params[variableName];
      }
    
      const lowerKey = variableName.toLowerCase();
      for (const key in params) {
        if (key.toLowerCase() === lowerKey) {
          return params[key];
        }
      }    
      return match;
    });
  }


}
